<template>
  <v-container>
    <h1 class="display-1 pt-3">Admin List</h1>
    <v-card class="pt-2 mt-2" flat="" outlined="">
      <v-data-table
        :headers="headers"
        :items="users"
        sort-by="email"
        class="elevation-0"
        :mobile-breakpoint="1000"
        :loading="isLoading"
        :search="search"
        loading-text="Loading users... Please wait"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <!-- <v-toolbar-title>Organization Admins</v-toolbar-title> -->
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark depressed="" class="mb-2" v-on="on"
                  >Invite User</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">Invite User</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="invite.email"
                          label="Email Address"
                        ></v-text-field>
                        <v-textarea
                          no-resize
                          autocomplete="off"
                          spellcheck="true"
                          name="input-9-1"
                          label="Custom Message"
                          hint="Leave a custom message, not required."
                          v-model="invite.message"
                          rows="3"
                          value
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12">
                        <p class="body-1 mb-0">Roles</p>
                        <span class="caption"
                          >These roles will be applied as soon as this user
                          accepts the invite.</span
                        >
                        <v-checkbox
                          v-model="invite.permissions"
                          label="Admin"
                          value="admin"
                          hide-details
                          color="blue"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="invite.permissions"
                          hide-details
                          label="Analyst"
                          value="analyst"
                          color="blue"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="invite.permissions"
                          hide-details
                          label="Distributor"
                          value="distribution"
                          color="blue"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="invite.permissions"
                          hide-details
                          label="Publisher"
                          value="publisher"
                          color="blue"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="invite.permissions"
                          hide-details
                          label="Writer"
                          value="writer"
                          color="blue"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions class="pa-3 pt-0">
                  <v-btn
                    depressed
                    color="grey white--text"
                    @click="
                      dialog = false;
                      invite.permissions = [];
                      invite.email = '';
                      invite.message = '';
                    "
                    >Cancel</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn
                    :disabled="!valid"
                    depressed
                    color="blue white--text "
                    @click="inviteUser"
                    >Invite</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.user.providerType="{ item }">
          {{ accountType(item.user.providerType) }}
        </template>
        <template v-slot:item.permissions="{ item }">
          <v-chip
            class="mr-1 mb-1 mt-1"
            small
            v-for="permission in sort(item.permissions)"
            :key="permission"
          >
            {{ permission }}
          </v-chip>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="updateUser(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteUser(item)">
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Invite User</v-btn>
        </template>
      </v-data-table>
    </v-card>
    <!-- Remove Confirm -->
    <a-confirm-modal :dialog="modals.deletemodal.open">
      <template slot="headline">
        Are you sure you want to remove this user?
      </template>
      <template slot="body"
        ><p>
          Once this user is removed, they will have to be re-invited as an
          admin. If you want to temporarily remove thier permissions, try
          editing this user instead.
        </p>
      </template>
      <template slot="actions">
        <v-btn depressed color="grey white--text" @click="deleteCancel"
          >Cancel</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn dark="" depressed color="red lighten-2" @click="deleteConfirm"
          >Remove User</v-btn
        >
      </template>
    </a-confirm-modal>
    <!-- Update User -->
    <a-confirm-modal :dialog="modals.update.open">
      <template slot="headline">
        Update {{ modals.update.email }}
      </template>
      <template slot="body">
        <!-- <span class="subtitle-1">{{ modals.update.email }}</span> -->
        <p class="body-1 mb-0">Roles</p>
        <span class="caption"
          >These roles will be applied to the current user.</span
        >
        <v-checkbox
          v-model="modals.update.permissions"
          label="Admin"
          value="admin"
          hide-details
          color="blue"
        ></v-checkbox>
        <v-checkbox
          v-model="modals.update.permissions"
          hide-details
          label="Analyst"
          value="analyst"
          color="blue"
        ></v-checkbox>
        <v-checkbox
          v-model="modals.update.permissions"
          hide-details
          label="Distributor"
          value="distribution"
          color="blue"
        ></v-checkbox>
        <v-checkbox
          v-model="modals.update.permissions"
          hide-details
          label="Publisher"
          value="publisher"
          color="blue"
        ></v-checkbox>
        <v-checkbox
          v-model="modals.update.permissions"
          hide-details
          label="Writer"
          value="writer"
          color="blue"
        ></v-checkbox>
      </template>
      <template slot="actions">
        <v-btn depressed color="grey white--text" @click="updateCancel"
          >Cancel</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn dark="" depressed color="blue" @click="updateConfirm"
          >Update User</v-btn
        >
      </template>
    </a-confirm-modal>
  </v-container>
</template>

<script>
import services from "@/services/index.js";
import confirmModal from "@/components/confirmation-modal";
export default {
  components: {
    "a-confirm-modal": confirmModal
  },
  data: () => ({
    isLoading: true,
    search: "",
    dialog: false,
    modals: {
      deletemodal: {
        open: false,
        id: ""
      },
      update: {
        open: false,
        permissions: [],
        id: "",
        email: ""
      }
    },
    headers: [
      {
        text: "Email Address",
        align: "left",
        sortable: true,
        value: "user.secure.email"
      },
      { text: "Account Type", value: "user.providerType" },
      {
        text: "Roles",
        value: "permissions",
        width: "50%",
        sortable: false
      },
      { text: "Actions", value: "action", sortable: false, align: "end" }
    ],
    users: [],
    editedIndex: -1,
    invite: {
      email: "",
      permissions: [],
      message: ""
    }
  }),
  computed: {
    valid() {
      return this.checkEmail(this.invite.email);
    }
  },
  created() {
    this.onLoad();
  },

  methods: {
    async updateUser(data) {
      this.modals.update.open = true;
      this.modals.update.id = data.user._id;
      this.modals.update.email = data.user.secure.email;
      this.modals.update.permissions = JSON.parse(
        JSON.stringify(data.permissions)
      );
    },
    updateCancel() {
      this.modals.update.open = false;
      this.modals.update.id = "";
      this.modals.update.email = "";
      this.modals.update.permissions = [];
    },
    async updateConfirm() {
      this.isLoading = true;
      try {
        await services.admin.editUser({
          id: this.modals.update.id,
          permissions: this.modals.update.permissions
        });
        this.updateCancel();
        await this.onLoad();
      } catch (err) {
        console.error(err);
      }
      this.updateCancel();
    },
    async deleteUser(data) {
      console.log("delete", data);
      this.modals.deletemodal.open = true;
      this.modals.deletemodal.id = data.user._id;
      console.log("id", this.modals.deletemodal.id);
    },
    deleteCancel() {
      this.modals.deletemodal.open = false;
    },
    async deleteConfirm() {
      this.modals.deletemodal.open = false;
      this.isLoading = true;
      try {
        await services.admin.removeUser({ id: this.modals.deletemodal.id });
      } catch (err) {
        console.error(err);
      }
      this.modals.deletemodal.open = false;
      this.modals.deletemodal.id = "";
      await this.onLoad();
      this.isLoading = false;
    },
    checkEmail(email) {
      {
        // eslint-disable-next-line no-useless-escape
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(email)) {
          return true;
        }
        return false;
      }
    },
    sort(array) {
      // console.log(array);
      let ideal = [
        "super admin",
        "admin",
        "analyst",
        "distribution",
        "publisher",
        "writer"
      ];
      return ideal.filter(x => {
        return array.includes(x);
      });
    },
    accountType(type) {
      switch (String(type).toLowerCase()) {
        case "arist_account":
          return "Arist General Account";
        case "google":
          return "Google Account";
        case "facebook":
          return "Facebook Account";
        default:
          return "Unknown";
      }
    },
    /**
     * Sends invite to requested email
     */
    async inviteUser() {
      if (!this.checkEmail(this.invite.email)) {
        return;
      }
      this.dialog = false;
      this.$store.commit("setLoading", true);
      try {
        await services.admin.inviteUser({
          email: this.invite.email,
          permissions: JSON.parse(JSON.stringify(this.invite.permissions))
        });
      } catch (err) {
        console.error(err);
      }
      try {
        window.analytics.track("Admin Invite Created");
      } catch (err) {
        console.error(err);
      }
      this.$store.commit("setLoading", false);
    },
    async onLoad() {
      this.isLoading = true;
      try {
        this.users = await services.admin.getAll();
        // console.log(this.users);
      } catch (err) {
        console.erorr(err);
      }
      this.isLoading = false;
    }
  }
};
</script>

<style></style>
